export default __webpack_public_path__ + "static/media/Spotify_logo_without_text.svg.6bd0249d.png";